
import { detectPlatformIos } from "core/utils/helper";
import { useEffect, useState } from "react";
import { LanguageTypeEnum } from "../LoginPage";
import Icon from 'core/assets/icons';
import { _t } from "core/language";
import API from "core/networks/API";
import { API_CHECK_SNS } from "modules/Auth/api";
import { useCustomNavigate, useNavigateStackCustom } from "core/hooks/useCustomNavigate";
import { RouterName } from '../../../../core/router';
import { useLoginClient } from "modules/Auth/hooks";
import { useAuthModal } from "core/context";
import { useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";


const ButtonLoginSns = (props: any) => {
  const navigate = useCustomNavigate();
  const { callPrevAction } = useAuthModal()
  const isAppIos = detectPlatformIos()
  const [checkLoginSocial, setCheckLoginSocial] = useState({ state: false, type: '' });
  const [popupLogin, setPopupLogin] = useState(false);
  const location = useLocation();
  const { getLastRoute } = useNavigateStackCustom();
  // const clientSetting = useSelector((state: any) => state.AppSettings);


  useEffect(() => {
    setPopupLogin(props?.popup)
  }, [props?.popup]);

  const _onSuccess = (dataLogin?:any) => {
    
    const lastRoute = getLastRoute(true);
    console.log(dataLogin,'dataLogin', lastRoute)
    // const code = getCodeLangById(dataLogin?.userInfo?.lang_id, clientSetting?.data?.languages);
    // // @ts-ignore
    // (window as any)._APP_LANG = code;
    // settingApplication();
    // setupAxios();
    
    setTimeout(() => {
      if (checkLoginSocial?.state && location?.pathname !== RouterName.SIGNUP_POLICY) {
        if (popupLogin || props?.popup) {
          if(location?.pathname === RouterName.MAIN){
            navigate(RouterName.MAIN+'?refresh=true')
          }
          callPrevAction?.()
        } else {
          navigate(lastRoute)
          callPrevAction?.()
        }
      }
    }, 350);

  };

  const _onFailed = (errors: any) => {
    console.log(errors)
  };

  const { handleLogin } = useLoginClient({
    onSuccess: _onSuccess,
    onFailed: _onFailed,
  });

  const handleCheckSns = async (data: any) => {
    const dataRequest = {
      sns_type: data.sns_type,
      sns_id: data.sns_id,
    }
    if (typeof props?.closeModal === 'function') {
      props?.closeModal()
      setTimeout(() => {
        setPopupLogin(true)
      }, 300);
    }
    try {
      const { data: response } = await API.post(`${API_CHECK_SNS}`, dataRequest)
      if (response && response?.code === 200) {
        handleLogin(data);
      }
    } catch (e: any) {
      console.log(e, 'e.response.data', props);
      if (e?.response?.data?.code === 404) {
        let paramLink = '?loginModal=true'
        if (location?.pathname === RouterName.LOGIN) {
          paramLink = '?loginPage=true'
        }
        navigate(RouterName.SIGNUP_POLICY + paramLink)
        localStorage.setItem('dataSns', JSON.stringify(data))
      }
    }
  }

  useEffect(() => {
    if (checkLoginSocial?.state) {

      if (typeof props?.setTypeLoginSns === 'function') {
        props?.setTypeLoginSns(checkLoginSocial?.type)
      }
      //login sns callback
      const snsCallback = (data: any) => {
        if (typeof data === 'string') {
          data = JSON.parse(data)
        }

        const snsData = data;
        let dataInfo = snsData?.data
        if (typeof dataInfo === 'string') {
          dataInfo = JSON.parse(dataInfo)
        }
        // alert((snsData.sns_id) + '__' + JSON.stringify(snsData))
        snsData.sns_id = dataInfo?.id
        snsData.sns_type = snsData?.type
        let dataInfoSns = snsData.data
        if (typeof dataInfoSns !== 'string') {
          dataInfoSns = JSON.stringify(dataInfoSns)
        }
        const dataSubmitSns = {
          sns_type: snsData?.sns_type || checkLoginSocial?.type,
          sns_id: snsData?.sns_id || snsData?.id,
          data: dataInfoSns,
          type: "sns"
        }
        handleCheckSns(dataSubmitSns)

      }
      // @ts-ignore
      window.nativeResponseSNSData = snsCallback;
    }

    return () => {
      // @ts-ignore
      window.nativeResponseSNSData = null
    }

  }, [checkLoginSocial?.state, handleCheckSns]);

  const _callAppleLogin = () => {
    setCheckLoginSocial({ type: LanguageTypeEnum.APPLE, state: true })
    // @ts-ignore
    window.webviewRequestSNSLogin({ type: LanguageTypeEnum.APPLE });
  }

  const _callFaceBookLogin = () => {
    setCheckLoginSocial({ type: LanguageTypeEnum.FACEBOOK, state: true })
    // @ts-ignore
    window.webviewRequestSNSLogin({ type: LanguageTypeEnum.FACEBOOK });
  }

  const _callGoogleLogin = () => {
    setCheckLoginSocial({ type: LanguageTypeEnum.GOOGLE, state: true })
    // @ts-ignore
    window.webviewRequestSNSLogin({ type: LanguageTypeEnum.GOOGLE });
  }

  const _callToPageLogin = () => {
    props?.closeModal()
    navigate(RouterName.LOGIN)
  }


  return (
    <section className="w-full">

      <div
        className="flex flex-col text-sm font-medium tracking-tighter text-center text-white"
        role="region"
        aria-label="Social Login Options"
      >
        {isAppIos && <div className="flex flex-col w-full rounded-none" onClick={_callAppleLogin}>
          <button
            className="relative flex gap-5 justify-center px-3.5 py-3 w-full bg-[#000000] rounded hover:bg-black/90 focus:outline-none"
            type="button"
          >
            <img
              loading="lazy"
              src={Icon.Apple}
              className="object-contain shrink-0 self-start aspect-square w-[18px] absolute left-[14px]"
              alt="Apple logo"
            />
            <span className="medium text-[14px]">{_t('auth.LabelSnsApple')}</span>
          </button>
        </div> }

        <div className="flex flex-col mt-2 w-full rounded-none" onClick={_callFaceBookLogin}>
          <button
            className="relative flex gap-5 justify-center px-3.5 py-3 w-full bg-[#3a6bf3] rounded hover:bg-blue-600 focus:outline-none"
            type="button"
          >
            <img
              loading="lazy"
              src={Icon.Facebook}
              className="object-contain shrink-0 self-start aspect-square w-[18px] absolute left-[14px]"
              alt="Facebook logo"
            />
            <span className="medium text-[14px]">{_t('auth.LabelSnsFacebook')}</span>
          </button>
        </div>

        <div className="flex flex-col mt-2 w-full rounded-none" onClick={_callGoogleLogin}>
          <button
            className="relative flex gap-5 justify-center px-3.5 py-3 w-full bg-white rounded border border-solid border-[#dddddd] fill-white stroke-zinc-300 text-neutral-900 hover:bg-gray-50 focus:outline-none"
            type="button"
          >
            <img
              loading="lazy"
              src={Icon.Google}
              className="object-contain shrink-0 self-start aspect-square w-[18px] absolute left-[14px]"
              alt="Google logo"
            />
            <span className="medium text-[14px]">{_t('auth.LabelSnsGoogle')}</span>
          </button>
        </div>
        {!props?.hideOptionGmail && <div className="flex flex-col mt-2 w-full rounded-none" onClick={_callToPageLogin}>
          <button
            className="relative flex gap-5 justify-center px-3.5 py-3 w-full bg-[#5bc467] rounded border border-solid border-[#dddddd] fill-white stroke-zinc-300 text-neutral-900 hover:bg-gray-50 focus:outline-none"
            type="button"
          >
            <img
              loading="lazy"
              src={Icon.Gmail}
              className="object-contain shrink-0 self-start aspect-square w-[18px] absolute left-[14px]"
              alt="Google logo"
            />
            <span className="medium text-[14px] text-[#ffffff]">{_t('auth.LabelSnsEmail')}</span>
          </button>
        </div> }
      </div>

      {/* <div className="flex gap-8 hidden">
        {
          isAppIos && <button onClick={_callAppleLogin} className="gap-y-2">
            <img

              src={Icon.Apple}
              alt={'Apple'}
              className="object-contain shrink-0 aspect-square w-[50px]"
            />
            {props?.btnText ? <label className="text-[11px] text-[#999999]">{_t('auth.LabelSnsApple')}</label> : ''}
          </button>
        }
        <button onClick={_callFaceBookLogin} className="gap-y-2">
          <img

            src={Icon.Facebook}
            alt={'Facebook'}
            className="object-contain shrink-0 aspect-square w-[50px]"
          />
          {props?.btnText ? <label className="text-[11px] text-[#999999]">{_t('auth.LabelSnsFacebook')}</label> : ''}
        </button>
        <button onClick={_callGoogleLogin} className="gap-y-2">
          <img

            src={Icon.Google}
            alt={'Google'}
            className="object-contain shrink-0 aspect-square w-[50px]"
          />
          {props?.btnText ? <label className="text-[11px] text-[#999999]">{_t('auth.LabelSnsGoogle')}</label> : ''}
        </button>
      </div> */}
    </section>
  );
};

export default ButtonLoginSns;
